import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured);
  const recentArticles = articles
    .filter((a) => !a.featured)
    .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())
    .slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            精选文章
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            深度解读，带你全面理解这部电影的每一个维度
          </p>
        </div>

        <div className="space-y-6 mb-10">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.slug} article={article} variant="featured" />
          ))}
        </div>

        <div>
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              最新文章
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {recentArticles.map((article) => (
              <ArticleCard key={article.slug} article={article} variant="default" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}